import { mobiClient } from '@/services/axiosConfig'
import { DataListReq, DataListRes } from './types'

export const getDataList = async (req: DataListReq): Promise<DataListRes | undefined> => {
  try {
    const headers = {
      isdn: req.isdn
    }
    const res = await mobiClient.get('/data', { headers })
    return res.data
  } catch (e) {
    console.error('fetch data list failed', e)
  }
}
